module.exports = __webpack_public_path__ + "img/feedback1-2.fd414800.jpg";